(() => {
  const formatEuroPriceText = value => value.replace(
    /(^|[ \t\u00a0]+)(?:€[ \t\u00a0]*|EUR[ \t\u00a0]+)(\d+(?:\.\d{3})*,\d{2})(?![\d,])/g,
    (_match, spacing, amount) => `${spacing ? ' ' : ''}${amount}\u00a0€`
  );
  const formatProductsAvailableText = (value, pluralTemplate, singularTemplate) => {
    const match = value.match(/^(\s*)([1-9]\d*) products? available(\s*)$/);
    const template = match?.[2] === '1' ? singularTemplate : pluralTemplate;
    if (!match || !template?.includes('[count]')) return value;
    return `${match[1]}${template.replace('[count]', match[2])}${match[3]}`;
  };
  const translateFilterScope = scope => {
    if (!scope) return;
    scope.querySelectorAll('p.sr-only[id^="filter-"][id$="-instructions"]').forEach(hint => {
      if (!hint.children.length && hint.textContent.trim() === 'Use this input to search the list of options below.') {
        hint.textContent = 'Durchsuche mit diesem Feld die folgenden Filteroptionen.';
      }
    });
    scope.querySelectorAll('button.gf-close-canvas[aria-label="Close filter"]').forEach(button => {
      button.setAttribute('aria-label', 'Filter schließen');
    });
    scope.querySelectorAll('a.refine-by-multi-filter[data-fid][data-fvalue][aria-label]').forEach(control => {
      const value = control.getAttribute('data-fvalue');
      if (value && control.getAttribute('aria-label') === `Remove filter value: ${value}`) {
        control.setAttribute('aria-label', `Filterwert entfernen: ${value}`);
      }
    });
  };
  if (typeof module !== 'undefined' && module.exports) {
    module.exports = { formatEuroPriceText, formatProductsAvailableText, translateFilterScope };
  }
  if (typeof document === 'undefined') return;
  const main = document.getElementById('MainContent');
  const data = document.getElementById('FilameltGloboLabels');
  if (!main || !data) return;
  const labels = JSON.parse(data.textContent);
  let queued = false;
  const update = () => {
    queued = false;
    const grid = main.querySelector('#gf-grid');
    if (!grid) return;
    // Only the observed Smart Filter accessibility strings, in German.
    // Reuse this asset's queued observer; no extra document-wide observer.
    if (/^de(?:-|$)/i.test(document.documentElement.lang)) {
      grid.querySelectorAll('.spf-product-card__price-wrapper').forEach(price => {
        const walker = document.createTreeWalker(price, NodeFilter.SHOW_TEXT);
        let node;
        while ((node = walker.nextNode())) {
          if (node.parentElement?.closest('.sr-only, .visually-hidden')) continue;
          const formatted = formatEuroPriceText(node.nodeValue);
          if (formatted !== node.nodeValue) node.nodeValue = formatted;
        }
      });
      const tree = main.querySelector('#gf-tree');
      const filterDialogs = Array.from(document.querySelectorAll('[role="dialog"]')).filter(dialog =>
        dialog.id === 'gf-tree'
        && dialog.querySelector('.gf-filter-contents, .gf-filter-header, [data-filter-id], a.refine-by-multi-filter[data-fid]')
      );
      [tree, grid, ...filterDialogs].forEach(translateFilterScope);
      const searchHint = grid.querySelector('p.sr-only#filtered-products-instructions');
      if (searchHint && !searchHint.children.length && searchHint.textContent.trim() === 'Use this input to search products in this collection.') {
        searchHint.textContent = 'Durchsuche mit diesem Feld die Produkte dieser Kollektion.';
      }
      const resultCount = grid.querySelector(
        'p#filtered-products-results-count.sr-only[aria-live="polite"][aria-atomic="true"]'
      );
      if (resultCount && !resultCount.children.length) {
        const formattedCount = formatProductsAvailableText(
          resultCount.textContent,
          labels.products_available,
          labels.product_available
        );
        if (formattedCount !== resultCount.textContent) resultCount.textContent = formattedCount;
      }
    }
    const products = grid.querySelector('#gf-products');
    const sort = grid.querySelector('#sortButton');
    const count = grid.querySelector('.gf-summary > b');
    const empty = products && count?.textContent.trim() === '0' && products.querySelector(':scope > .spf-col-xl-12');
    const ready = sort && (products?.querySelector('.spf-product-card') || empty);
    const wrapper = grid.closest('.filamelt-collection, .template-search');
    if (wrapper) wrapper.classList.toggle('fm-globo-ready', Boolean(ready));
    const replaceLabel = (element, value) => {
      if (!element || !value) return;
      if (element.textContent.trim() !== value) element.textContent = value;
    };
    const selected = sort?.querySelector('span');
    if (selected?.textContent.trim() === 'most_relevant') replaceLabel(selected, labels.relevance);
    if (selected?.textContent.trim() === 'Best Seller') replaceLabel(selected, labels.best_selling);
    grid.querySelectorAll('#globo-dropdown-sort_options li').forEach(option => {
      const text = option.textContent.trim();
      const value = text === 'most_relevant' ? labels.relevance : text === 'Best Seller' ? labels.best_selling : null;
      if (value) {
        replaceLabel(option, value);
        option.setAttribute('aria-label', value);
      }
    });
    if (empty && wrapper?.classList.contains('template-search')) {
      const notices = products.querySelectorAll(':scope > .spf-col-xl-12');
      if (notices[0] && !notices[0].querySelector('.spf-product-card')) replaceLabel(notices[0], labels.no_results);
      if (notices[1]?.querySelector('.spf-heading') && !notices[1].querySelector('.spf-product-card')) notices[1].hidden = true;
    }
  };
  const schedule = () => {
    if (!queued) { queued = true; requestAnimationFrame(update); }
  };
  new MutationObserver(schedule).observe(main, { subtree: true, childList: true, characterData: true });
  document.addEventListener('click', schedule, true);
  update();
})();

